import React from "react";
import "./Footer.css";
import { ThemeContext } from "../../Context/theme";

export const Footer = () => {
  const [{ themename }] = React.useContext(ThemeContext);

  return (
    <>
      <div className={"section " + themename}>
        <a href="https://github.com/talib789" rel="noreferrer" target="_blank">
          <h3 className="footer">Made with <img src="https://media.tenor.com/NRtK5xTyAEsAAAAj/heart-red.gif" alt="Heart"/> by Md Talib Ansari </h3>
        </a>
      </div>
      
      <div>
        <h5 className="footerlast"> All rights reserved © 2022 Md Talib
        </h5>
      </div>
    </>
  );
};
